let paymentMethods = {
    None: [],
    AR: [
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Pago Fácil',
            filename: 'PF.svg',
        },
        {
            name: 'Rapi Pago',
            filename: 'RP.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
        {
            name: 'Banco Ciudad',
            filename: 'IO_BC.svg',
        },
        {
            name: 'Banco Industrial',
            filename: 'IO_IN.svg',
        },
        {
            name: 'Banco Nación',
            filename: 'IO_NA.svg',
        },
        {
            name: 'Banco Provincia',
            filename: 'IO_PR.svg',
        },
        {
            name: 'BBVA',
            filename: 'IO_BV.svg',
        },
        {
            name: 'Citi',
            filename: 'IO_CI.svg',
        },
        {
            name: 'Credicoop',
            filename: 'IO_CR.svg',
        },
        {
            name: 'Galicia',
            filename: 'IO_GA.svg',
        },
        {
            name: 'HSBC',
            filename: 'IO_H.svg',
        },
        {
            name: 'Itaú',
            filename: 'IO_I.svg',
        },
        {
            name: 'Macro',
            filename: 'IO_MA.svg',
        },
        {
            name: 'Santander',
            filename: 'IO_SB.svg',
        },
    ],
    BO: [
        {
            name: 'Banco Nacional de Bolivia',
            filename: 'IO.svg',
        },
    ],
    BR: [
        {
            name: 'PIX',
            filename: 'PQ.svg',
        },
        {
            name: 'Banco do Brasil',
            filename: 'BB.svg',
        },
        {
            name: 'Bradesco',
            filename: 'B.svg',
        },
        {
            name: 'Caixa',
            filename: 'CA.svg',
        },
        {
            name: 'Itau',
            filename: 'I.svg',
        },
        {
            name: 'Santander',
            filename: 'SB.svg',
        },
    ],
    CL: [
        {
            name: 'ServiPag',
            filename: 'SP.svg',
        },
        {
            name: 'Webpay',
            filename: 'WP.svg',
        },
        {
            name: 'Banco Bice',
            filename: 'WP_BB.svg',
        },
        {
            name: 'Banco Consorcio',
            filename: 'WP_BC.svg',
        },
        {
            name: 'Banco de Chile',
            filename: 'WP_CH.svg',
        },
        {
            name: 'Banco Estado',
            filename: 'WP_BE.svg',
        },
        {
            name: 'Banco Falabella',
            filename: 'WP_BF.svg',
        },
        {
            name: 'Banco Internacional',
            filename: 'WP_BI.svg',
        },
        {
            name: 'Banco Ripley',
            filename: 'WP_BR.svg',
        },
        {
            name: 'Banco Security',
            filename: 'WP_BS.svg',
        },
        {
            name: 'BBVA',
            filename: 'WP_BV.svg',
        },
        {
            name: 'BCI-TBANC',
            filename: 'WP_BT.svg',
        },
        {
            name: 'Coopeuch',
            filename: 'WP_CO.svg',
        },
        {
            name: 'Corpbanca',
            filename: 'WP_CB.svg',
        },
        {
            name: 'Dale Coopeuch',
            filename: 'WP_DA.svg',
        },
        {
            name: 'Itaú',
            filename: 'WP_IT.svg',
        },
        {
            name: 'Prepago Los Héroes',
            filename: 'WP_LH.svg',
        },
        {
            name: 'Santander',
            filename: 'WP_SB.svg',
        },
        {
            name: 'Scotia Bank',
            filename: 'WP_SC.svg',
        },
        {
            name: 'Superdigital',
            filename: 'WP_SU.svg',
        },
        {
            name: 'Tenpo',
            filename: 'WP_TE.svg',
        },
    ],
    CO: [
        {
            name: 'Baloto',
            filename: 'WP_TE.svg',
        },
        {
            name: 'Efecty',
            filename: 'EY.svg',
        },
        {
            name: 'PSE',
            filename: 'PC.svg',
        },
        {
            name: 'Almacenes Éxito',
            filename: 'BU_EX.svg',
        },
        {
            name: 'Banco Agrario',
            filename: 'PC_AG.svg',
        },
        {
            name: 'Banco AV Villas',
            filename: 'PC_VL.svg',
        },
        {
            name: 'Banco Caja Social',
            filename: 'PC_CS.svg',
        },
        {
            name: 'Banco Colpatria',
            filename: 'PC_CP.svg',
        },
        {
            name: 'Banco Corpbanca S.A',
            filename: 'PC_CB.svg',
        },
        {
            name: 'Banco de Bogotá',
            filename: 'PC_BO.svg',
        },
        {
            name: 'Banco de Occidente',
            filename: 'PC_OC.svg',
        },
        {
            name: 'Banco Falabella',
            filename: 'PC_FA.svg',
        },
        {
            name: 'Banco GNB Sudameris',
            filename: 'PC_GN.svg',
        },
        {
            name: 'Banco Pichincha S.A.',
            filename: 'PC_PI.svg',
        },
        {
            name: 'Banco Popular',
            filename: 'PC_PO.svg',
        },
        {
            name: 'Banco Procredit',
            filename: 'PC_PR.svg',
        },
        {
            name: 'Bancolombia',
            filename: 'PC_BC.svg',
        },
        {
            name: 'Bancoomeva S.A.',
            filename: 'PC_BM.svg',
        },
        {
            name: 'BBVA Colombia S.A.',
            filename: 'PC_BV.svg',
        },
        {
            name: 'Carulla',
            filename: 'BU_CR.svg',
        },
        {
            name: 'Citibank',
            filename: 'PC_CI.svg',
        },
        {
            name: 'Colsubsidio',
            filename: 'BU_XS.svg',
        },
        {
            name: 'ConSuerte',
            filename: 'BU_XU.svg',
        },
        {
            name: 'Coopenessa',
            filename: 'BU_XC.svg',
        },
        {
            name: 'Davivienda',
            filename: 'DA.svg',
        },
        {
            name: 'Edeq',
            filename: 'BU_DQ.svg',
        },
        {
            name: 'Gana Cerca de Ti',
            filename: 'BU_GC.svg',
        },
        {
            name: 'Gana Gana',
            filename: 'BU_GG.svg',
        },
        {
            name: 'Helm Bank S.A.',
            filename: 'PC_HE.svg',
        },
        {
            name: 'JER',
            filename: 'BU_JE.svg',
        },
        {
            name: 'La 14',
            filename: 'BU_LF.svg',
        },
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Su Chance',
            filename: 'BU_CX.svg',
        },
        {
            name: 'Super Giros',
            filename: 'BU_SG.svg',
        },
        {
            name: 'SuperInter',
            filename: 'BU_XI.svg',
        },
        {
            name: 'Surti Mayorista',
            filename: 'BU_SM.svg',
        },
        {
            name: 'Surtimax',
            filename: 'BU_SX.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
    ],
    CR: [
        {
            name: 'Tucan',
            filename: 'TU.svg',
        },
        {
            name: 'Exprés',
            filename: 'PU.svg',
        },
    ],
    EC: [
        {
            name: 'Pago Efectivo',
            filename: 'EF.svg',
        },
        {
            name: 'Almacenes TIA',
            filename: 'EF_AT.svg',
        },
        {
            name: 'Banco Amazonas',
            filename: 'EF_BA.svg',
        },
        {
            name: 'Coac 29 Octubre',
            filename: 'EF_CO.svg',
        },
        {
            name: 'Facilito',
            filename: 'EF_FO.svg',
        },
        {
            name: 'Farmacias 911',
            filename: 'EF_F9.svg',
        },
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Mi comisariato',
            filename: 'EF_MC.svg',
        },
        {
            name: 'Mi Negocio Efectivo',
            filename: 'EF_NE.svg',
        },
        {
            name: 'Oro Cash',
            filename: 'EF_OR.svg',
        },
        {
            name: 'Ponle+',
            filename: 'EF_PO.svg',
        },
        {
            name: 'Servientrega',
            filename: 'EF_SE.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
        {
            name: 'Western Union',
            filename: 'EF_WU.svg',
        },
    ],
    GT: [
        {
            name: 'Akisí',
            filename: 'PU.svg',
        },
    ],
    MX: [
        {
            name: 'OXXO',
            filename: 'OX.svg',
        },
        {
            name: 'Spei',
            filename: 'SE.svg',
        },
        {
            name: 'Banbajio',
            filename: 'SE_BB.svg',
        },
        {
            name: 'Banco Azteca',
            filename: 'SE_AZ.svg',
        },
        {
            name: 'Banorte',
            filename: 'SE_BQ.svg',
        },
        {
            name: 'Banregio',
            filename: 'SE_BR.svg',
        },
        {
            name: 'BBVA Bancomer',
            filename: 'SE_BV.svg',
        },
        {
            name: 'Carnet Debit',
            filename: 'KD.svg',
        },
        {
            name: 'Citibanamex',
            filename: 'SE_BM.svg',
        },
        {
            name: 'Compartamos',
            filename: 'SE_CO.svg',
        },
        {
            name: 'HSBC',
            filename: 'SE_H.svg',
        },
        {
            name: 'Inbursa',
            filename: 'SE_IN.svg',
        },
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Santander',
            filename: 'SE_SB.svg',
        },
        {
            name: 'Scotiabank',
            filename: 'SE_SC.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
    ],
    PY: [
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
    ],
    PE: [
        {
            name: 'Pago Efectivo',
            filename: 'EF.svg',
        },
        {
            name: 'Agente KasNet',
            filename: 'EF_KA.svg',
        },
        {
            name: 'Agente Red Digital',
            filename: 'EF_RD.svg',
        },
        {
            name: 'BanBif',
            filename: 'EF_BB.svg',
        },
        {
            name: 'Banco Azteca',
            filename: 'EF_BZ.svg',
        },
        {
            name: 'Banco de la Nación',
            filename: 'EF_BN.svg',
        },
        {
            name: 'Banco Pichincha',
            filename: 'EF_BP.svg',
        },
        {
            name: 'BBVA',
            filename: 'BP.svg',
        },
        {
            name: 'BCP',
            filename: 'BC.svg',
        },
        {
            name: 'Caja Arequipa',
            filename: 'EF_JA.svg',
        },
        {
            name: 'Caja del Santa',
            filename: 'EF_CD.svg',
        },
        {
            name: 'Caja los Andes',
            filename: 'EF_CL.svg',
        },
        {
            name: 'Caja Paita',
            filename: 'EF_CP.svg',
        },
        {
            name: 'Caja Raíz',
            filename: 'EF_CR.svg',
        },
        {
            name: 'Caja Sullana',
            filename: 'EF_CS.svg',
        },
        {
            name: 'Caja Trujillo',
            filename: 'EF_JR.svg',
        },
        {
            name: 'Dale',
            filename: 'EF_DA.svg',
        },
        {
            name: 'Disashop',
            filename: 'EF_DI.svg',
        },
        {
            name: 'Fullcarga',
            filename: 'EF_FL.svg',
        },
        {
            name: 'Interbank',
            filename: 'IB.svg',
        },
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Niubiz Multiservicios',
            filename: 'EF_CN.svg',
        },
        {
            name: 'Perú Express-MoneyGram',
            filename: 'EF_MG.svg',
        },
        {
            name: 'Scotiabank',
            filename: 'ST.svg',
        },
        {
            name: 'Tambo+',
            filename: 'EF_TA.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
        {
            name: 'Western Union',
            filename: 'EF_WU.svg',
        },
    ],
    UY: [
        {
            name: 'Abitab',
            filename: 'AI.svg',
        },
        {
            name: 'Redpagos',
            filename: 'RE.svg',
        },
        {
            name: 'MasterCard Debit',
            filename: 'MD.svg',
        },
        {
            name: 'Visa Debit',
            filename: 'VD.svg',
        },
    ],
}

export {paymentMethods};
